(()=>{

  let blocks = document.querySelectorAll('.tabs-pages > .shopify-block');

  blocks.forEach( (block, i) => {
    // only show first page initially
    if(i != 0) { block.style.display = 'none'; }

    let pageBtnTitle = block.querySelector('.page-title').innerHTML;
    let pageBtn = document.createElement('button');

    pageBtn.classList.add('page-btn');
    pageBtn.innerHTML = pageBtnTitle;
    pageBtn.setAttribute('data-page', i);
    if(i == 0) { pageBtn.classList.add('active'); }
    pageBtn.addEventListener('click', (e) => {
      e.preventDefault();
      blocks.forEach( block => {
        block.style.display = 'none';
      })
      blocks[i].style.display = 'block';
      document.querySelectorAll('.page-btn').forEach( btn => {
        btn.classList.remove('active');
      });
      e.target.classList.add('active');
    })
    document.querySelector('.tabs-page-menu').appendChild(pageBtn);
    //block.parentNode.insertBefore(pageBtn, block); 

    
  })


  document.querySelectorAll('.tab-page-inner-container').forEach( (container, i) => {

    console.log('container', container);
    let tabs = container.querySelectorAll('.shopify-block');
    //let tabs = [...container.getElementsByClassName('shopify-block')];

    //console.log('tabs', tabs);

    // find first available tab with a .tab-title so we can show it initially
    let firstAvailableTabFound = false;
    let firstAvailableTabIndex = -1;
    tabs.forEach( (tab, h) => {
      if (firstAvailableTabFound) { return;}

      if(tab.querySelector('.tab-title')){
        firstAvailableTabFound = true;
        firstAvailableTabIndex = h;
      }
    })

    tabs.forEach( (tab, j) => {
      // only show first tab
      console.log('tab html', tab.innerHTML);
      if(j != firstAvailableTabIndex) { tab.style.display = 'none'; }

      if(tab.querySelector('.tab-title')){
        let tabBtnTitle = tab.querySelector('.tab-title').innerHTML;
        let tabBtn = document.createElement('button');

        tabBtn.classList.add('tab-btn');
        tabBtn.innerHTML = tabBtnTitle;
        tabBtn.setAttribute('data-tab', j);
        if(j == firstAvailableTabIndex) { tabBtn.classList.add('active'); }

        tabBtn.addEventListener('click', (e) => {
          e.preventDefault();
          tabs.forEach( tab => {
            tab.style.display = 'none';
          })
          tabs[j].style.display = 'block';
          container.querySelectorAll('.tab-btn').forEach( btn => {
            btn.classList.remove('active');
          });
          e.target.classList.add('active');
        });
        container.querySelector('.tab-menu').appendChild(tabBtn);
      }

    })
  });

  [...document.getElementsByClassName('tabs-page-container')].forEach( el => {
    el.style.display = 'flex';
  });

})();